import {FlightMode} from "../FlightMode";
import {FlightModeGameAssets} from "../FlightModeGameAssets";
import {gsap} from "gsap";
import {BasedCountUp} from "./BasedCountUp";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class FreespinsOutro extends PIXI.Container {

    public outroSpine:PIXI.spine.Spine;
    public darkening:PIXI.Sprite;
    public countUp:BasedCountUp;
    public totalWin:PIXI.Text;
    public freespinsPlayed:PIXI.Text;

    constructor() {
        super();

        this.darkening = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.darkening.tint = PIXI.utils.string2hex("#0066ff");
        this.darkening.position.set(360, 360);
        this.darkening.anchor.set(0.5, 0.5);
        this.darkening.alpha = 0;
        this.addChild(this.darkening);

        this.outroSpine =
            new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.OUTRO_SPINE));
        this.outroSpine.position.set(360,360);
        this.outroSpine.alpha = 0;
        this.addChild(this.outroSpine);

        this.countUp = new BasedCountUp();
        this.countUp.position.set(360, 240);
        this.countUp.visible = false;
        this.addChild(this.countUp);

        const totalWinStyle = new PIXI.TextStyle({
            "dropShadow": true,
            "dropShadowAngle": 1.5,
            "dropShadowColor": "#000033",
            "fill": "#ffff00",
            "fontFamily": "Helvetica",
            "fontSize": 50,
            "fontWeight": "bold",
            "lineJoin": "round",
            "stroke": "#000033",
            "strokeThickness": 8,
            "padding": 12,
        });
        this.totalWin = new PIXI.Text(NolimitApplication.apiPlugin.translations.translate("TOTAL WIN"), totalWinStyle);
        this.totalWin.position.set(360, 150);
        this.totalWin.anchor.set(0.5, 0.5);
        this.totalWin.visible = false;
        this.addChild(this.totalWin);

        this.freespinsPlayed = new PIXI.Text(FlightMode.apiPlugin.translations.translate("Spins played: 69"), totalWinStyle);
        this.freespinsPlayed.anchor.set(0.5,0.5);
        this.freespinsPlayed.position.set(360,450);
        this.freespinsPlayed.visible = false;
        this.addChild(this.freespinsPlayed);
    }

    public show():gsap.core.Timeline {
        const didntProfit = FlightMode.isWinBelowStake() || FlightMode.model.accumulatedRoundWin == 0;
        return gsap.timeline()
            .add(gsap.to(this.darkening, {alpha: 0.7, duration:0.25}))
            .add(() => {
                this.outroSpine.state.setAnimation(0, "FS_Outro_Loop", true);
                this.outroSpine.alpha = 1;
                this.totalWin.visible = !didntProfit;
                this.countUp.visible = true;
            }, '<')
            .add(didntProfit
                ? this.countUp.countUpInstant(FlightMode.model.accumulatedRoundWin, 0)
                : this.countUp.countUp(FlightMode.model.accumulatedRoundWin, 0, 2), '<')
            .add(() => {
                if (!FlightMode.isWinBelowStake())
                    FlightMode.soundPlayer.playSound("fsOutroRevealStuff");
                this.freespinsPlayed.visible = true;
                this.freespinsPlayed.scale.set(1,1);
                const spinPlayed: number = FlightMode.model.freespinsPlayed;
                this.freespinsPlayed.text =
                    FlightMode.apiPlugin.translations.translate("Spins played: ${spinPlayed}").replace("${spinPlayed}", spinPlayed.toString());
                if (this.freespinsPlayed.width > 700) {
                    const newScale = 700 / this.freespinsPlayed.width;
                    this.freespinsPlayed.scale.set(newScale, newScale);
                }

            }, '>0.3')
            .add(() => {}, '>0.3');
    }

    public hide():gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.darkening, {alpha: 0, duration:0.25}))
            .add(() => {
                this.outroSpine.alpha = 0;
                this.outroSpine.state.setEmptyAnimation(0,0);
                this.countUp.visible = false;
                this.totalWin.visible = false;
                this.freespinsPlayed.visible = false;
            }, '<');
    }

}